import URLs from '~/constants/urls';
import API from './utils/API';

class YoutubeAPI extends API {
  private readonly API_KEY = process.env.YOUTUBE_API_KEY;

  getPlaylist = (playlistId: string) => {
    const req = this.fetchHelper.createNoTokenGetRequest(
      `${this.endpoint}/playlistItems`,
      {
        playlistId,
        key: this.API_KEY,
        part: ['snippet'].join(','),
        maxResults: 50,
      },
      false
    );

    return this.fetch(req);
  };

  getVideoLengths = (videoIds: string[]) => {
    const req = this.fetchHelper.createNoTokenGetRequest(
      `${this.endpoint}/videos`,
      {
        id: videoIds.join(','),
        key: this.API_KEY,
        part: ['contentDetails'].join(','),
        maxResults: 50,
      },
      false
    );

    return this.fetch(req);
  };

  mapYoutubePlaylistResponse = (items): { videoId: string; title: string; thumbnail: string }[] => {
    return items.map((item) => ({
      videoId: item.snippet.resourceId.videoId,
      title: item.snippet.title,
      thumbnail: item.snippet.thumbnails?.default?.url,
    }));
  };

  mapYoutubeVideoLengthsResponse = (
    items
  ): Record<string, Record<'minutes' | 'seconds', string>> => {
    return items.reduce((acc, curr) => {
      const regexResult = /PT((\w{1,2})H)?((\w{1,2})M)?((\w{1,2})S)?/.exec(
        curr.contentDetails.duration
      );

      acc[curr.id] = {
        minutes: regexResult?.[4] ?? '0',
        seconds: regexResult?.[6] ?? '0',
      };
      return acc;
    }, {});
  };
}

export default new YoutubeAPI(URLs.YOUTUBE_API);
